<template>
<div>

<FieldLabel v-if="showFieldHelp" :label="item.name" :help="fieldHelp" :input-id="fieldInputId" :field-id="item.id" :modal-key="modalKey" />
<v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        min-width="auto"
        v-if="prop.show"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
          :id="fieldInputId"
          :label="showFieldHelp ? undefined : item.name"
          :aria-label="item.name"
            v-model="translateResult"
            @click:append="menu = true"
            v-bind="attrs"
            readonly
            v-on="on"
            dense
            :rules="prop.modelRules"
            :outlined="prop.outlined"
            :filled="prop.filled"
            :solo="prop.solo"
            :hint="prop.description"
            :persistent-hint="prop.persistenthint"
            :disabled="prop.disabled"
            :class="prop.class"
            :clearable="prop.clearable"
            :color="prop.coloronselect"
            @click:clear="model = null"

            :prepend-icon="(prop.iconlr=='prepend' && prop.iconinout=='out') ? prop.iconmdi : ''"
            :prepend-inner-icon="(prop.iconlr=='prepend' && prop.iconinout!='out') ? prop.iconmdi : ''"
            :append-icon="(prop.iconlr=='append' && prop.iconinout!='out') ? prop.iconmdi : ''"
            :append-outer-icon="(prop.iconlr=='append' && prop.iconinout=='out') ? prop.iconmdi : ''" 

          ></v-text-field>
        </template>
        <v-date-picker
          v-model="model"
          locale="fr"
          no-title
          scrollable
        >
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="menu = false"
          >
            Annuler
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.menu.save(model)"
          >
            OK
          </v-btn>
        </v-date-picker>

      </v-menu>

</div>
</template>



<script>

import mixinFields from '../../mixins/Fields'
import mixinConditionsFields from '../../mixins/conditionsFields'
    export default {
        name : 'datePicker',

        mixins : [mixinFields,mixinConditionsFields],

        data: function() {
            return { 
                translateResult : '',
                menu : false
            }
        },

        computed: {

        },

        watch : { 

           model(val) {
              const empty = val === null
                || typeof val === 'undefined'
                || (typeof val === 'string' && [
                  '',
                  '0000-00-00',
                  '0000-00-00 00:00:00'
                ].includes(val.trim()))

              if (empty) {
                const value = null
                this.translateResult = this.prop.placeholder || 'Choisir une date'
                this.change(this.item, value)
                this.changeStoreOnField({ item: this.item, model: value, page: this.modalKey })
                return
              }

              const parsed = this.moment(val)
              if (!parsed.isValid()) {
                this.translateResult = this.prop.placeholder || 'Choisir une date'
                this.change(this.item, null)
                this.changeStoreOnField({ item: this.item, model: null, page: this.modalKey })
                return
              }

              const value = parsed.format('YYYY-MM-DD')
              this.change(this.item, value)
              this.changeStoreOnField({ item: this.item, model: value, page: this.modalKey })
              this.translateResult = parsed.format('DD-MM-YYYY')
              this.menu = false
           },

           valField(val) {
            this.model = val
           }

        },

        methods : {

        },

    }

</script>
